import React, { useRef, useCallback, useEffect } from "react";
import { Link } from 'react-router-dom';
import { List } from 'components/general/List';
import { getGlobalProps } from 'state-management/selectors'
import { useSelector } from 'react-redux'
import { useSwiper } from 'swiper/react';
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation, A11y, Manipulation } from "swiper";
import { useUrlFriendlyToParameters, useGetURL } from "helpers/urlFriendly";
import { Score as ScoreGlobal } from "components/presentation/Score"
import { getCompetitorType } from "pages/sports/BracketDraw";
import Card from 'react-bootstrap/Card';
import Label from "components/general/Label"
import DateTime from "components/presentation/DateTime";
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Status from "components/presentation/Status";
import { sortDataByFieldDesc } from "helpers/utils";
/**
 * Component return a Crousel with a list of Units from phase
*/
export default function UnitsSlide({ items }) {

    SwiperCore.use([Navigation])
    const globalProps = useSelector(getGlobalProps)
    const _phaseSelected = globalProps.components.phaseSelector.elementSelected
    const swiperRef = useRef();
    let phasesEvent = [];
    const { mirs_rsc, mirs_language, mirs_competition, mirs_discipline } = useUrlFriendlyToParameters();
    /*
    
    if (_phaseSelected !== "") {
        phasesEvent = items ? items.filter(row => (row.code === _phaseSelected)) : []
        phasesEvent = phasesEvent ? phasesEvent[0] : []
    } else {
        //phasesEvent = (items?.event?.phases) ? items.event.phases.filter(row => (row.type === '3')) : []
        phasesEvent = (items)
        phasesEvent = phasesEvent ? phasesEvent[2] : []
    }

    const units = (phasesEvent && phasesEvent.units) ? phasesEvent.units : []
    const unitsFilter = (units) ? units.filter(row => (row.type !== 'NONE')) : []

*/
    let excludeArray = [
        "ARCMINDIVID-----------QUAL1",
        "ARCWINDIVID-----------QUAL1",
        "ARCMTEAM3-------------QUAL1",
        "ARCWTEAM3-------------QUAL1",
        "ARCXTEAM2-------------QUAL1",
        "CLBMSPEED-------------QUAL",
        "CLBWSPEED-------------QUAL"
    ]

    let units = [];
    //EVENTS FILTER 
    let results = items?.events?.filter(event => (event.order !== 0))

    if (!items?.events) {
        results = [items?.event]
    }


    //READ all Units 
    results && results.forEach((item, index) => {
        //item = item?.phases.filter(p => p !== "ARCMINDIVID-----------QUAL")
        item?.phases?.forEach((phase, index) => {
            if (!excludeArray.includes(phase.code) || mirs_rsc === "EG2023") {
                phase?.units?.forEach((unit, index) => {
                    if(unit?.scheduled === 'Y' && unit?.schedule) { //we avoid to put units without schedules as re-run and others
                        units.push(unit)
                    }
                })
            }
        })
        //items.push(...item)
    })


    const unitsFilter = (units) ? units.filter(row => (row?.type !== 'NONE')) : []
    unitsFilter?.sort((a, b) => new Date(a?.schedule?.startDate) - new Date(b?.schedule?.startDate)).result?.items?.sort((a, b) => a?.sortOrder - b?.sortOrder);


    const sliderRef = useRef(null);
    const btnPrev = useRef(null);
    const btnNext = useRef(null);

    useEffect(() => {
        onSlideChange()
    }, []);

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
    }, []);

    const onSlideChange = useCallback(() => {
        // left postion
        if (sliderRef.current.swiper.activeIndex === 0) {
            btnPrev.current.style = 'visibility: hidden';
            btnNext.current.style = 'visibility: visible';
        }
        // right postion
        else if (sliderRef.current.swiper.activeIndex === sliderRef.current.swiper.slides.length - 2) {
            btnPrev.current.style = 'visibility: visible';
            btnNext.current.style = 'visibility: hidden';
        }
        // middle positions
        else {
            btnPrev.current.style = 'visibility: visible';
            btnNext.current.style = 'visibility: visible';
        }
    }, []);



    let _breakpoints = {
        768: {
            slidesPerGroup: 2,
            slidesPerView: 2
        },
        1024: {
            slidesPerGroup: 3,
            slidesPerView: 3
        },
        1200: {
            slidesPerGroup: 4,
            slidesPerView: 4
        },
        1500: {
            slidesPerGroup: mirs_discipline === 'BDM' ? 4 : 5,
            slidesPerView: mirs_discipline === 'BDM' ? 4 : 5
        }
    }

    return (
        <>
            <div className='container d-flex ribbon-container'>
                <div className="prev-arrow" ref={btnPrev} onClick={handlePrev} ><span className="prev-txt"></span></div>
                <Swiper
                    breakpoints={_breakpoints}

                    //slidesPerGroup={5}
                    //slidesPerView={5}
                    spaceBetween={5}
                    onSlideChange={() => onSlideChange()}
                    ref={sliderRef}
                    //slidesPerView={2}
                    //navigation={true}
                    pagination={{ clickable: true, }}
                    modules={[Pagination, Navigation, A11y]}
                    //slidesPerView={1}
                    observer={true}
                    watchSlidesProgress={true}
                    className="mirs-swiper"
                >

                    <UnitList items={unitsFilter} />
                </Swiper>
                {/*
                <button onClick={() => swiperRef.pagination.render()}>
                    Go to Next Slide
                </button>
                 */}
                <div className="next-arrow" ref={btnNext} onClick={handleNext} ><span className="next-txt"></span></div>
            </div>
        </>
    );
}





//Workaround in order to put UnitList inside wraper Slider
UnitList.displayName = 'SwiperSlide'


export function UnitList({ items }) {

    //SORT
    const postList = items ? (

        <List
            items={items}
            resourceName="data"
            itemComponent={EventUnitItem}
        />


    ) : (
        ''
    )
    return (
        <>{postList}</>
    )
}

export function EventUnitItem({ data }) {
    let params = useUrlFriendlyToParameters();
    //Copy object in order to change 
    let paramsURL = { ...params }
    //const url = getURL(paramsURL, 'schedule')
    paramsURL["mirs_rsc"] = data.code
    const { mirs_discipline } = params

    //replace with useGetURL 
    const url = useGetURL(paramsURL, 'results')
    const CompetitorComponent = getCompetitorType(mirs_discipline)



    //const dataScore = data?.bracketCompetitors[0]?.resultItem?.resultDataText && JSON.parse(data?.bracketCompetitors[0]?.resultItem?.resultDataText)
    //const swPSO = dataScore?.extra?.pso
    //sortDataByFieldDesc(unitsFilter,)

    let unitComponents
    if (Array.isArray(data?.schedule?.result?.items) && data?.schedule?.result?.items.length > 2) {
        unitComponents = ''
    } else {
        unitComponents = data?.schedule?.result?.items
            //?.sort((a, b) => a.sortOrder - b.sortOrder)
            ?.map((competitor, index) => {
                return (
                    <div key={`matchH2H${competitor}-${index}`} className={`score-line  d-flex flex-row ${competitor?.resultWLT?.includes('W') ? 'fw-bold' : ''} `}>
                        <CompetitorComponent {...competitor} />
                        <ScoreGlobal resultJson={competitor?.resultDataText} discipline={mirs_discipline} key={`score-${data.code}-${competitor?.sortOrder}`} type='RIBBON'/>
                    </div>
                )
            })
    }
    //let bracketBlock = unitComponents
    /*
    if (swPSO) {
        bracketBlock = <><div className="d-flex flex-row">
            <div className="w-90">
                {bracketBody}
            </div>
            <div className="m-auto fw-bold"><SportCode discipline={mirs_discipline} code={'PSO'} entity={'@Period'} abbr={'true'} /></div>
        </div></>
    }
    */
    const disciplines = ['JUD']
    let presentationGame = data?.description;
    let numberGame = JSON.stringify()// findArray(data?.schedule?.results?.extendedInfos, { ei_code: ['UNIT_NUMBER'] }).ei_value;


    if (disciplines.includes(mirs_discipline)) {
        presentationGame = <>{presentationGame}, <Label data='HeaderContest' /> {numberGame} </>;
    }

    return (
        <SwiperSlide
            className={`ribbon-element  ${(params.mirs_rsc === data.code) ? "active" : ""}`}
            data-unit={data.code}>
            <Link to={url}>
                < Card className={`score-match`}>
                    <Card.Header>
                        <div className='score-header'>
                            <strong><span>{presentationGame}</span></strong>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        {unitComponents}
                    </Card.Body>
                    <Card.Footer>
                        <Footer data={data?.schedule} />
                    </Card.Footer>

                </Card >

            </Link>
        </SwiperSlide >


    )
}



function Footer({ data }) {
    const formatDate = Label({ data: 'BracketDateFormat' });
    const formatDateTime = Label({ data: 'BracketDateTimeFormat' });


    const dateTimeFormated = data?.startDate && <DateTime datetime={data?.startDate} format={formatDateTime} />

    return (
        <>

            {<div className='text-start'>{dateTimeFormated}</div>}
            {<div className='score-status justify-content-end'>
                <Status typeToPrint={'result'} scheduleStatus={data?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
        </>
    )
}